<div *ngIf="needSearch" class="header-container">
    <app-input
        [(value)]="params.keyword"
        (refresh)="handleRefresh()"
    ></app-input>

    <button class="search-button text-btn-primary" nz-button (click)="handleRefresh()">Search</button>
</div>

<app-st
    #st
    [loading]="loading"
    [columns]="columns"
    [data]="data"
    [page]="{ show: true }"
    [ps]="size"
    [pi]="page + 1"
    [total]="total"
    [templates]="{ action: action }"
    (changes)="handleChange($event)"
    [scroll]="nzScroll"
>
    <ng-template #action let-row>
        <button nz-button nzSize="small"class="text-btn-primary" nz-tooltip="Open Link" [disabled]="actionDisabled" (click)="view(row)" *ngIf="judgeIsLink(row.path)">
            <em nz-icon nzType="link" nzTheme="outline"></em>
        </button>
        <button nz-button nzSize="small"class="text-btn-primary" nz-tooltip="Edit" [disabled]="actionDisabled" (click)="edit(row)" *ngIf="judgeIsLink(row.path)">
            <em nz-icon nzType="edit" nzTheme="outline"></em>
        </button>
        <div *ngIf="!judgeIsLink(row.path)" style="display: inline-block">
            <button nz-tooltip="Download" *appPermission="ticketId ? [] : ['Task Document Download']" [disabled]="actionDisabled" nz-button nzSize="small"class="text-btn-primary" (click)="handleDownload(row)">
                <em nz-icon nzType="download" nzTheme="outline"></em>
            </button>
        </div>

        <button nz-tooltip="Delete" *appPermission="ticketId ? [] : ['Task Document Delete']" [disabled]="actionDisabled" nz-button nzSize="small" class="text-btn-danger" (click)="handleRemove(row)" [disabled]="!canEditDelete">
            <em nz-icon nzType="delete" nzTheme="outline"></em>
        </button>
    </ng-template>
</app-st>
